import { AddOrderReturn as AddOrderReturnV1 } from 'app/menu/components/TopBarV1/AddOrderReturnReg'

export const AddOrderReturn = AddOrderReturnV1
export default AddOrderReturn
